"use client";
import NextTopLoader from "nextjs-toploader";
import type { ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

const ProgressProvider = ({ children }: Readonly<Props>) => {
  return (
    <>
      {children}
      <NextTopLoader
        color="#ff6252"
        initialPosition={0.2}
        crawlSpeed={200}
        height={4}
        crawl={true}
        showSpinner={false}
        easing="ease"
        speed={200}
      />
    </>
  );
};

export default ProgressProvider;
